import script from "./collectPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./collectPopup.vue?vue&type=script&setup=true&lang=ts"

import "./collectPopup.vue?vue&type=style&index=0&id=2db467e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2db467e6"]])

export default __exports__